export default __webpack_public_path__ + "static/media/delete-v2.69044b78.svg";